import { RootState } from '../../../../../../../../init-store';
import { ContainerDrawer } from '../common-drawers/container-drawer';
import { Area } from '../types';
import { CommandsDrawer, getCommandsHeight } from './commands-drawer';
import { SCALE } from './constants';
import { CONTROLS_HEIGHT, ControlsDrawer } from './controls-drawer';
import { HEADER_HEIGHT, HeaderDrawer } from './header-drawer';

// Header
const HEADER_MARGIN_BOTTOM = Math.round(32 * SCALE);
// Command list
const COMMANDS_MARGIN_BOTTOM = Math.round(32 * SCALE);
// Container
const CONTAINER_PADDING = Math.round(32 * SCALE);
const CONTAINER_WIDTH = Math.round(500 * SCALE);

type Drawers = {
    containerDrawer: ContainerDrawer;
    headerDrawer: HeaderDrawer;
    commandsDrawer: CommandsDrawer;
    controlsDrawer: ControlsDrawer;
};

let DRAWERS: Drawers | null = null;
let LAST_COMMANDS_HEIGHT: number | null = null;

function initDrawers(ctx: CanvasRenderingContext2D, state: RootState): Drawers {
    const commandsHeight = getCommandsHeight(state);
    const containerHeight =
        CONTAINER_PADDING +
        HEADER_HEIGHT +
        HEADER_MARGIN_BOTTOM +
        commandsHeight +
        COMMANDS_MARGIN_BOTTOM +
        CONTROLS_HEIGHT;
    const containerArea: Area = {
        x: Math.round((ctx.canvas.width - CONTAINER_WIDTH) / 2),
        y: Math.round((ctx.canvas.height - containerHeight) / 2),
        width: CONTAINER_WIDTH,
        height: containerHeight,
    };
    const containerDrawer = new ContainerDrawer(containerArea);

    const headerArea: Area = {
        x: containerArea.x + CONTAINER_PADDING,
        y: containerArea.y + CONTAINER_PADDING,
        width: containerArea.width - CONTAINER_PADDING * 2,
        height: HEADER_HEIGHT,
    };
    const headerDrawer = new HeaderDrawer(headerArea);

    const commandsArea: Area = {
        x: containerArea.x + CONTAINER_PADDING,
        y: headerArea.y + headerArea.height + HEADER_MARGIN_BOTTOM,
        width: containerArea.width - CONTAINER_PADDING * 2,
        height: commandsHeight,
    };
    const commandsDrawer = new CommandsDrawer(commandsArea);

    const controlsFullArea: Area = {
        x: containerArea.x,
        y: commandsArea.y + commandsArea.height + COMMANDS_MARGIN_BOTTOM,
        width: containerArea.width,
        height: CONTROLS_HEIGHT,
    };
    const controlsContentArea: Area = {
        x: containerArea.x + CONTAINER_PADDING,
        y: controlsFullArea.y,
        width: containerArea.width - CONTAINER_PADDING * 2,
        height: CONTROLS_HEIGHT,
    };
    const controlsDrawer = new ControlsDrawer(controlsFullArea, controlsContentArea);

    return {
        containerDrawer,
        headerDrawer,
        commandsDrawer,
        controlsDrawer,
    };
}

export function drawCommandList(ctx: CanvasRenderingContext2D, state: RootState) {
    const currentCommandsHeight = getCommandsHeight(state);
    if (!DRAWERS || LAST_COMMANDS_HEIGHT !== currentCommandsHeight) {
        DRAWERS = initDrawers(ctx, state);
        LAST_COMMANDS_HEIGHT = currentCommandsHeight;
    }

    DRAWERS.containerDrawer.draw(ctx);
    DRAWERS.headerDrawer.draw(ctx);
    DRAWERS.commandsDrawer.draw(ctx, state);
    DRAWERS.controlsDrawer.draw(ctx);
}
